import styled from 'styled-components';

export const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: calc(100vh - 138px);
  padding: 0 0 70px 0;

  ${Styles.desktop`
    height: 80vh;
    justify-content: center;
    padding: 15rem 3rem 3rem;
  `}
  // Reset to Desktop
  @media screen and (min-width: 769px) {
    padding: 15rem 6rem 10rem;
  }
`;
